import { render, staticRenderFns } from "./SignupMain.pug?vue&type=template&id=742fae01&lang=pug&external"
import script from "./SignupMain.js?vue&type=script&lang=js&external"
export * from "./SignupMain.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports